export default __webpack_public_path__ + "static/media/Dashboard.d6694047.svg";